import React from 'react'

import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  HttpLink,
  from,
} from '@apollo/client'
import {onError, ErrorResponse} from '@apollo/client/link/error'
import {useSnackbar} from 'notistack'

import {useMeStore} from '@progyny/store/meStore'
import {REACT_APP_GRAPHCMS_ENDPOINT_URL} from '@progyny/utils/env'

type GraphQLWrapperProps = {
  children: React.ReactNode
}

const GraphQLWrapper = ({children}: GraphQLWrapperProps) => {
  const {enqueueSnackbar} = useSnackbar()
  const user = useMeStore((s) => s.user)
  const errorHandler = ({graphQLErrors, networkError}: ErrorResponse) => {
    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        enqueueSnackbar(err.message, {
          variant: 'error',
        })
      }
    }

    if (networkError) {
      enqueueSnackbar(networkError.message, {
        variant: 'error',
      })
    }
  }

  const link = from([
    onError(errorHandler),
    new HttpLink({
      uri: `${REACT_APP_GRAPHCMS_ENDPOINT_URL}`,
      headers: {
        authorization: `${user?.hygraphAuthToken}`,
      },
    }),
  ])

  const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default GraphQLWrapper

export function withHygraphWrapper<Type>(ChildComp: React.ComponentType<Type>) {
  return class Component extends React.Component<Type> {
    render() {
      const props = this.props
      return (
        <GraphQLWrapper>
          <ChildComp {...props} />
        </GraphQLWrapper>
      )
    }
  }
}
